export default "__VITE_ASSET__poLVDR2T__"